<script lang="ts">
	import { getGameDate, siteDateFormat } from '$lib/helpers/app.documents';
	import { asText } from '@prismicio/client';
	import { PrismicImage } from '@prismicio/svelte';

	const { game, highlight, showtag } = $props();
	const isHome = game.data.home_team.uid == 'cardiff-eagles' ? true : false;
	const homeScore = game.data.home_score ?? 0;
	const awayScore = game.data.away_score ?? 0;
</script>

<article class="game" class:highlight>
	{#if showtag}
		<div class="game__latest-next">
			<span>Latest Result</span>
		</div>
	{/if}

	<div class="d-flex align-items-center">
		<div class="game__logo--container">
			<PrismicImage
				field={isHome ? game.data.home_team.data.logo : game.data.away_team.data.logo}
				class="game__logo"
				loading="lazy"
			/>
		</div>

		<div class="game__details">
			<div class="game__arena">{game.data.arena}</div>

			{#if isHome}
				<h3 class="game__opposition"><small>vs</small> {asText(game.data.away_team.data.name)}</h3>
			{:else}
				<h3 class="game__opposition"><span>@</span> {asText(game.data.home_team.data.name)}</h3>
			{/if}

			<div class="game__date">
				<div class="date">{getGameDate(game.data.date_time, siteDateFormat)}</div>
				<div class="type">{game.data.type}</div>
			</div>
		</div>
	</div>

	<div class="game__score">
		<div class="game__score--home">
			<span>{game.data.home_team.data.short_name}</span>
			<h2 class:team={homeScore > awayScore}>{homeScore}</h2>
		</div>

		<span class="game__score--break">-</span>

		<div class="game__score--away">
			<span>{game.data.away_team.data.short_name}</span>
			<h2 class:team={awayScore > homeScore}>{awayScore}</h2>
		</div>
	</div>
</article>

{@html `
	<script type="application/ld+json">
		{
			"@context": "https://schema.org",
			"@type": "SportsEvent",
			"name": "${asText(game.data.home_team.data.name)} vs ${asText(game.data.away_team.data.name)}",
			"startDate": "${game.data.date_time}",
			"eventStatus": "https://schema.org/EventCompleted",
			"sport": "Ice Hockey",
			"homeTeam": {
				"@type": "SportsTeam",
				"name": "${asText(game.data.home_team.data.name)}",
				"score": ${homeScore}
			},
			"awayTeam": {
				"@type": "SportsTeam",
				"name": "${asText(game.data.away_team.data.name)}",
				"score": ${awayScore}
			},
			"organizer": {
				"@type": "Organization",
				"name": "${game.data.type}"
			}
		}
	</script>
`}
